import { SingleDonation as SingleDonationForm } from '@bgea-js/form-templates';
import "../../../../src/content/fountain-hills-fundraiser/fountain-hills-fundraiser.scss";
import * as React from 'react';
export default {
  SingleDonationForm,
  React
};